import { render, staticRenderFns } from "./ModeleList.vue?vue&type=template&id=60cc4b40&"
import script from "./ModeleList.vue?vue&type=script&lang=js&"
export * from "./ModeleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports